import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/straightline.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 35, 1, 12 Bl. 16<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1693 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (161k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Demonstrating That a Straight Line Can Be Drawn from One Point to Another</title>
            <meta name="description" content="An English translation of DEMONSTRATING THAT A STRAIGHT LINE CAN BE DRAWN FROM ONE POINT TO ANOTHER by Gottfried Wilhelm Leibniz, from 1693 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: DEMONSTRATING THAT A STRAIGHT LINE CAN BE DRAWN FROM ONE POINT TO ANOTHER</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>Leibniz here seeks to demonstrate the first postulate (&quot;To draw a straight line from any point to any point&quot;) of book 1 of Euclid's <var>Elements</var>.</small><br /><br /><br />
		        [<b>LH 35, 12, 1 Bl. 16</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;That a straight line can be drawn from one point to another could be demonstrated from the fact that two points can be conceived as lying in the same plane. An infinite straight line, when rotated about a centre situated in that plane, meets all the points of the plane; and when it meets the given [point], the part of the moved line intercepted between the centre and the given point is the straight line sought. However many points there may be in a common space, any three are in a common plane, and any two are in a common straight line.

                <br /><br /><br />
                &#169; Lloyd Strickland 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
